var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6719 19.9434C21.082 20.3535 21.082 20.9688 20.6719 21.3379C20.5078 21.543 20.2617 21.625 20.0156 21.625C19.7285 21.625 19.4824 21.543 19.2773 21.3379L13.7812 15.8418C12.3047 17.0312 10.459 17.6875 8.49023 17.6875C3.81445 17.6875 0 13.873 0 9.15625C0 4.48047 3.77344 0.625 8.49023 0.625C13.166 0.625 17.0215 4.48047 17.0215 9.15625C17.0215 11.166 16.3652 13.0117 15.1758 14.4473L20.6719 19.9434ZM1.96875 9.15625C1.96875 12.8066 4.88086 15.7188 8.53125 15.7188C12.1406 15.7188 15.0938 12.8066 15.0938 9.15625C15.0938 5.54688 12.1406 2.59375 8.53125 2.59375C4.88086 2.59375 1.96875 5.54688 1.96875 9.15625Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d67a8b6500548535aae7f5fe46e4bfa4.svg";
export { ForwardRef as ReactComponent };